import { render, staticRenderFns } from "./SummaryKasbon.vue?vue&type=template&id=e2b5746a"
import script from "./SummaryKasbon.vue?vue&type=script&lang=js"
export * from "./SummaryKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports